module.exports = __webpack_public_path__ + "img/1Reihe_1.3fc39562.jpg";